import { BaseIcon } from '../BaseIcon';
import type { SizedIconProps } from '../BaseIcon';
import { IconSize } from '../../../../enums';

type CommentIconProps = Omit<SizedIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const CommentIcon = ({ strokeWidth, size = IconSize.Standard, ...props }: CommentIconProps) => {
  const sizeInPixel = size === IconSize.Mini ? 12 : 24;

  return (
    <BaseIcon
      width={sizeInPixel}
      height={sizeInPixel}
      viewBox="0 0 12 12"
      fill="none"
      strokeWidth={strokeWidth}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 0C1.11929 0 0 1.11929 0 2.5V5.5C0 6.88071 1.11929 8 2.5 8H6V11.5C6 11.7022 6.12182 11.8845 6.30866 11.9619C6.4955 12.0393 6.71055 11.9966 6.85355 11.8536L10.8536 7.85355C10.8876 7.81952 10.9236 7.78426 10.9609 7.74766C11.169 7.54376 11.4195 7.29826 11.6113 6.99208C11.8533 6.60558 12 6.13686 12 5.5V2.5C12 1.11929 10.8807 0 9.5 0H2.5ZM10.1464 7.14645C10.1931 7.09982 10.2373 7.05618 10.2793 7.01473C10.4864 6.81047 10.64 6.65896 10.7637 6.46135C10.8967 6.24899 11 5.96771 11 5.5V2.5C11 1.67157 10.3284 1 9.5 1H2.5C1.67157 1 1 1.67157 1 2.5V5.5C1 6.32843 1.67157 7 2.5 7H6.5C6.77614 7 7 7.22386 7 7.5V10.2929L10.1464 7.14645Z"
        fill="#141B4D"
      />
    </BaseIcon>
  );
};

CommentIcon.displayName = 'CommentIcon';
